import axios from "axios";
import { SERVER } from "./SERVER";

class PanelDataService {
    getAllPanels(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/panels/`);
    }
    getAllArchive(year, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/panels/year/${year}`);
    }
    createPanel(data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/create/panel/`, data);
    }
    getPanel(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/panel/${id}/`);
    }
    updatePanel(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/panel/${id}/`, data);
    }
    deletePanel(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/panel/${id}/`);
    }
    toggleChecked(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/panel/checked/${id}/`);
    }
    toggleArchived(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/panel/archive/${id}/`);
    }
    updateDueDate(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/panel/due/${id}/`, data);
    }
}

export default new PanelDataService();
